
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, union_type, class_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__startLoading, FormState_get_empty, FormState_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { UploadType_$reflection } from "./FileUploadDialog.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { deleteDocumentReminderLinkCmd } from "../../Requests/Consumable.js";
import { deleteDocumentReminderLinkCmd as deleteDocumentReminderLinkCmd_1 } from "../../Requests/ToolWithQuantity.js";
import { deleteDocumentReminderLinkCmd as deleteDocumentReminderLinkCmd_2 } from "../../Requests/Set.js";
import { Cmd_deleteToolDocumentReminderLinkCmd } from "../../Requests/Tool.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DocumentReminderLinkDeleted", "DeleteReminderLink", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.Dialogs.DeleteReminderLinkDialog.Msg", [], Msg, () => [[["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", class_type("System.Exception")]]]);
}

export class State extends Record {
    constructor(FormState, SuccessCallback, OnClose, LinkId, UploadType) {
        super();
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.LinkId = LinkId;
        this.UploadType = UploadType;
    }
}

export function State_$reflection() {
    return record_type("Widgets.Dialogs.DeleteReminderLinkDialog.State", [], State, () => [["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["LinkId", string_type], ["UploadType", UploadType_$reflection()]]);
}

function init(successCallback, onClose, linkId, uploadType) {
    return [new State(FormState_get_empty(), successCallback, onClose, linkId, uploadType), Cmd_none()];
}

function update(msg, state) {
    switch (msg.tag) {
        case 0:
            if (msg.fields[0].tag === 1) {
                return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.LinkId, state.UploadType), Cmd_errorToast("general.a_error_occured")];
            }
            else {
                return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.LinkId, state.UploadType), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                }), Cmd_successToast("general.success")]))];
            }
        case 2:
            return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.LinkId, state.UploadType), Cmd_none()];
        default: {
            const matchValue = state.UploadType;
            switch (matchValue.tag) {
                case 1:
                    return [new State(FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.LinkId, state.UploadType), deleteDocumentReminderLinkCmd(matchValue.fields[0], state.LinkId, (Item_2) => (new Msg(0, [Item_2])), (Item_3) => (new Msg(2, [Item_3])))];
                case 2:
                    return [new State(FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.LinkId, state.UploadType), deleteDocumentReminderLinkCmd_1(matchValue.fields[0], state.LinkId, (Item_4) => (new Msg(0, [Item_4])), (Item_5) => (new Msg(2, [Item_5])))];
                case 3:
                    return [new State(FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.LinkId, state.UploadType), deleteDocumentReminderLinkCmd_2(matchValue.fields[0], state.LinkId, (Item_6) => (new Msg(0, [Item_6])), (Item_7) => (new Msg(2, [Item_7])))];
                case 4:
                    return [state, Cmd_none()];
                default:
                    return [new State(FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.LinkId, state.UploadType), Cmd_deleteToolDocumentReminderLinkCmd(matchValue.fields[0], state.LinkId, (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(2, [Item_1])))];
            }
        }
    }
}

export function DeleteDocumentReminderLinkDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.SuccessCallback, props.OnClose, props.LinkId, props.UploadType), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    return createElement(ConfirmationDialog, (Title = t("general.delete"), {
        Description: t("document_reminder_relation.delete_query"),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        OnConfirm: patternInput_1[0].FormState.IsLoading ? (() => {
        }) : (() => {
            patternInput_1[1](new Msg(1, []));
        }),
        Title: Title,
    }));
}

